import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const appId = typeof __app_id !== 'undefined' ? __app_id : 'classroom-hub-prototype';
const envFirebaseConfig = {
  apiKey: "AIzaSyAAP3XxnVoi7ESASY2ooMcGGxYRewwsqkY",
  authDomain: "hub.physicslens.com",
  projectId: "myhub-98e08",
  storageBucket: "myhub-98e08.appspot.com",
  messagingSenderId: "114996772332",
  appId: "1:114996772332:web:a3cbea487a1e808ad294c9",
  measurementId: "G-MS68LRYD1W"
};

const firebaseConfig = typeof __firebase_config !== 'undefined'
  ? JSON.parse(__firebase_config)
  : envFirebaseConfig;

const hasValidConfig = Boolean(
  firebaseConfig.apiKey &&
  firebaseConfig.projectId &&
  firebaseConfig.appId
);

const app = hasValidConfig ? initializeApp(firebaseConfig) : null;
export const auth = hasValidConfig ? getAuth(app) : null;
export const db = hasValidConfig
  ? initializeFirestore(app, {
      // Some browsers/networks block Firestore's WebChannel transport;
      // auto-detecting long polling avoids recurring Write/channel 404/400 failures.
      experimentalAutoDetectLongPolling: true,
      useFetchStreams: false
    })
  : null;
export const functions = hasValidConfig ? getFunctions(app) : null;
export const storage = hasValidConfig ? getStorage(app) : null;
export const isFirebaseEnabled = hasValidConfig;
export { app, appId };
